import { errorResponse } from "../api-interface";
import apiService from "../api-service";

// ============================================================================
// Dashboard API Functions
// ============================================================================

// Types
export interface Brand {
  brand_id: string;
  brand_name: string;
}

export interface BrandsResponse {
  brands: Brand[];
}

export interface Channel {
  channel_id: string;
  channel_name: string;
}

export interface ChannelsResponse {
  channels: Channel[];
}

/**
 * Fetch list of brands from database
 * @param token - Optional access token for authentication
 * @returns Promise with brands response
 */
export const getBrands = async (token?: string) => {
  try {
    const url = `/brands`;
    
    const response = await apiService.get({
      url,
      accessToken: token,
    });

    return response;
  } catch (error: any) {
    return errorResponse(error?.message || "Failed to fetch brands");
  }
};

/**
 * Fetch list of channels from database
 * @param token - Optional access token for authentication
 * @returns Promise with channels response
 */
export const getChannels = async (token?: string) => {
  try {
    const url = `/channels`;
    
    const response = await apiService.get({
      url,
      accessToken: token,
    });

    return response;
  } catch (error: any) {
    return errorResponse(error?.message || "Failed to fetch channels");
  }
};
